export const staticConfig = window.__midasStaticConfig_invoiceH5 || {}

/**
 * 发票抬头填写信息条目
 * @type {{individual: {}, organization: {invoiceTitle: {text: string, tag: string, type: string}}, company: {invoiceType: {text: string, type: string}, invoiceTitle: {text: string, tag: string, type: string, required: boolean}, taxpayerId: {text: string, tag: string, type: string, required: boolean}, companyAddr: {text: string, tag: string, type: string, required: boolean}, companyPhone: {text: string, tag: string, type: string, required: boolean}, companyBankName: {text: string, tag: string, type: string, required: boolean}, companyBankAcct: {text: string, tag: string, type: string, required: boolean}}}}
 */
export const invoiceTitleFiled = {
  individual: [
    {
      key: "invoiceTitle",
      name: "发票抬头名称",
      tag: "input",
      component: "form-input",
      type: "text",
      required: true,
      placeholder: "请填写本人姓名(2~4个汉字)",
      maxlength: 20
    }
  ],
  organization: [
    {
      key: "invoiceTitle",
      name: "发票抬头名称",
      tag: "textarea",
      component: "form-textarea",
      placeholder: "请填写发票抬头",
      required: true,
      type: "text",
      rows: 2
    },
    {
      key: "socialCreditCode",
      name: "统一社会信用代码",
      tag: "input",
      component: "form-input",
      placeholder: "请填写统一社会信用代码", //一组长度为18位的 数字+字母 的组合  禁止输入文字
      required: false,
      verify: "CheckSocialCreditCode",
      verifyErrorMsg: "统一社会信用代码为18位数字或大写英文字母",
      maxlength: 18,
      type: "text",
      verifyType: "code"
    }
  ],
  company: [
    // {
    //   key: "invoiceType",
    //   name: "发票类型",
    //   tag: "input",
    //   component: "form-radio",
    //   type: "radio",
    //   required: true,
    //   options: [
    //     {
    //       name: "普通发票",
    //       key: "invoiceType",
    //       for: "ordinary",
    //       value: "3",
    //       radioName: "invoice-sort",
    //       checked: true
    //     }
    //     //TODO 二期加入纸质发票
    //     // {
    //     //   name: "增值税专用发票",
    //     //   key: "invoiceType",
    //     //   for: "dedicated",
    //     //   value: "4",
    //     //   radioName: "invoice-sort",
    //     //   checked: false
    //     // }
    //   ]
    // },
    {
      key: "invoiceTitle",
      name: "发票抬头名称",
      tag: "textarea",
      component: "form-textarea",
      type: "text",
      required: true,
      placeholder: "请填写发票抬头",
      rows: 2
    },
    {
      key: "taxpayerId",
      name: "纳税人识别号",
      tag: "input",
      component: "form-input",
      type: "text",
      placeholder: "纳税人识别号必须为15,18或20位", // /^[A-Za-z0-9]+$/ 禁止输入文字
      required: true,
      verify: "checkTaxpayerId",
      verifyErrorMsg: "纳税人识别号输入有误",
      maxlength: 20,
      verifyType: "code"
    },
    {
      key: "companyAddr",
      name: "单位地址",
      tag: "input",
      component: "form-input",
      type: "text",
      placeholder: "填写公司地址",
      required: false
    },
    {
      key: "companyPhone",
      name: "单位电话",
      tag: "input",
      component: "form-input",
      type: "tel",
      placeholder: "填写公司电话",
      required: false,
      maxlength: 20,
      verifyType: "phone"
    },
    {
      key: "companyBankName",
      name: "单位开户银行",
      tag: "input",
      component: "form-input",
      type: "text",
      placeholder: "填写收票公司开户银行",
      required: false
    },
    {
      key: "companyBankAcct",
      name: "单位开户银行账号",
      tag: "input",
      component: "form-input",
      type: "tel",
      placeholder: "填写收票公司银行账号", //禁止输入文字
      required: false,
      maxlength: 26,
      verifyType: "bank"
    }
  ],
  special: [
    // {
    //   key: "sendTo",
    //   name: "收件人姓名",
    //   tag: "input",
    //   component: "form-input",
    //   type: "text",
    //   placeholder: "请输入收件人姓名",
    //   required: true
    // },
    // {
    //   key: "sendAddr",
    //   name: "收件地址",
    //   tag: "input",
    //   component: "form-input",
    //   type: "text",
    //   placeholder: "请详细描述省、市、区、街道(路）、门牌号",
    //   required: true
    // },
    // {
    //   key: "sendPhone",
    //   name: "联系手机",
    //   tag: "input",
    //   component: "form-input",
    //   type: "tel",
    //   placeholder: "请输入可接收短信的手机号码",
    //   required: true,
    //   maxlength: 20,
    //   verifyType: "phone"
    // },
    // {
    //   key: "postalCode",
    //   name: "邮编号码",
    //   tag: "input",
    //   component: "form-input",
    //   type: "tel",
    //   placeholder: "请输入当地邮政号码",
    //   required: true,
    //   maxlength: 20,
    //   verifyType: "phone"
    // },
    // {
    //   key: "sendProvince",
    //   name: "收件地址省份",
    //   tag: "input",
    //   component: "form-input",
    //   type: "text",
    //   placeholder: "请输入收件地址省份",
    //   required: true
    // },
    // {
    //   key: "sendCity",
    //   name: "收件地址城市",
    //   tag: "input",
    //   component: "form-input",
    //   type: "text",
    //   placeholder: "请输入收件地址城市",
    //   required: true
    // },
    // {
    //   key: "district",
    //   name: "收件地址区县",
    //   tag: "input",
    //   component: "form-input",
    //   type: "text",
    //   placeholder: "请输入收件地址区县",
    //   required: true
    // },
    {
      key: "proofs",
      name: "《充值及开票声明》（个人签名＋ 公司盖章）",
      tag: "upload",
      component: "form-upload",
      type: "upload",
      placeholder: "",
      required: true,
      checkKey: "statement",
      preview: "statement"
    }
  ],
  specialTitle: [
    {
      key: "invoiceTitle",
      name: "发票抬头名称",
      tag: "textarea",
      component: "form-textarea",
      placeholder: "请填写发票抬头",
      required: true,
      type: "text",
      rows: 2
    },
    {
      key: "taxpayerId",
      name: "纳税人识别号",
      tag: "input",
      component: "form-input",
      type: "text",
      placeholder: "纳税人识别号必须为15,18或20位", // /^[A-Za-z0-9]+$/ 禁止输入文字
      required: true,
      verify: "checkTaxpayerId",
      verifyErrorMsg: "纳税人识别号输入有误",
      maxlength: 20,
      verifyType: "code"
    },
    // {
    //   key: "companyAddr",
    //   name: "注册地址",
    //   tag: "input",
    //   component: "form-input",
    //   type: "text",
    //   placeholder: "请输入公司详细地址",
    //   required: true
    // },
    // {
    //   key: "companyPhone",
    //   name: "注册电话",
    //   tag: "input",
    //   component: "form-input",
    //   type: "tel",
    //   placeholder: "请输入公司电话号码",
    //   required: true,
    //   maxlength: 20,
    //   verifyType: "phone"
    // },
    {
      key: "companyBankName",
      name: "开户银行",
      tag: "input",
      component: "form-input",
      type: "text",
      placeholder: "请输入完整银行名称",
      required: false
    },
    {
      key: "companyBankAcct",
      name: "银行账号",
      tag: "input",
      component: "form-input",
      type: "tel",
      placeholder: "请输入公司银行账户", //禁止输入文字
      required: false,
      maxlength: 26,
      verifyType: "bank"
    },
    {
      key: "establishTime",
      name: "公司成立时间",
      tag: "input",
      component: "form-date",
      type: "date",
      placeholder: "请选择日期",
      required: true
    },
    {
      key: "proofs",
      name: "多证合一营业执照复印件（加盖企业公章）",
      tag: "upload",
      component: "form-upload",
      type: "upload",
      placeholder: "",
      required: true,
      isOther: true,
      checkKey: "certificateList",
      preview: "certificate"
    }
  ]
}

//抬头校验
export const invoiceTitleCheck = {
  socialCreditCode: {
    verifyFunc: "simplyCheckSocialCreditCode",
    verifyErrorMsg:
      (staticConfig.verifyErrorMsg && staticConfig.verifyErrorMsg.socialCreditCode) ||
      "统一社会信用代码为18位数字或大写英文字母"
  },
  taxpayerId: {
    verifyFunc: "simplyCheckTaxpayerId",
    verifyErrorMsg:
      (staticConfig.verifyErrorMsg && staticConfig.verifyErrorMsg.taxpayerId) ||
      "纳税人识别号必须为15,18或20位数字或大写英文字母"
  },
  invoiceTitle: {
    verifyFunc: "simplyCheckStrLength",
    verifyLength: 100,
    verifyErrorMsg:
      (staticConfig.verifyErrorMsg && staticConfig.verifyErrorMsg.invoiceTitle) ||
      "发票抬头名称最大长度为100个字符或50个汉字"
  },
  companyAddr: {
    verifyFunc: "simplyCheckStrLength",
    verifyLength: 60,
    verifyErrorMsg:
      (staticConfig.verifyErrorMsg && staticConfig.verifyErrorMsg.companyAddr) || "单位地址最大长度为60个字符或30个汉字"
  },
  companyBankName: {
    verifyFunc: "simplyCheckStrLength",
    verifyLength: 80,
    verifyErrorMsg:
      (staticConfig.verifyErrorMsg && staticConfig.verifyErrorMsg.companyBankName) ||
      "单位开户银行最大长度为80个字符或33个汉字 "
  },
  establishTime: {
    verifyFunc: "simplyCheckDate",
    verifyErrorMsg: "公司成立时间不能早于当天"
  }
  // companyPhone: {
  //   verifyFunc: "checkTel",
  //   verifyErrorMsg: "公司电话输入有误"
  // },
  // companyBankAcct: {
  //   verifyFunc: "checkBankCard",
  //   verifyErrorMsg: "银行账号输入有误"
  // }
}

/**
 * 按抬头类型覆写校验规则
 * 当某个 tab 下的字段 key 与全局 invoiceTitleCheck 同名但规则不同时，在这里覆写
 * 优先级：invoiceTitleCheckByType[tab][key] > invoiceTitleCheck[key]
 * tab 取值参考 invoiceTitleType：1-个人 2-组织 3-公司普票 4-公司专票
 */
export const invoiceTitleCheckByType = {
  // 个人发票抬头：限制 2-4 个汉字
  1: {
    invoiceTitle: {
      verifyFunc: "checkPersonalInvoiceTitle",
      verifyErrorMsg:
        (staticConfig.verifyErrorMsg && staticConfig.verifyErrorMsg.personalInvoiceTitle) ||
        "请输入本人真实姓名（2-4个汉字），如有疑问请联系客服。"
    }
  }
}

//发票抬头类型  1-个人 2-组织 3-公司普票 4-公司专票（必填）
export const invoiceTitleType = {
  1: "individual",
  2: "organization",
  3: "company",
  4: "special",
  "4-1": "specialTitle"
}

//发票类型  1-电子发票 2-纸质发票
export const invoiceType = {
  ELECTRONIC: "electronic",
  PAPER: "paper"
}

export const recordFields = {
  individual: [
    {
      key: "invoiceTitle",
      name: "发票抬头"
    },
    {
      key: "invoiceAmount",
      name: "发票金额"
    },
    {
      key: "createTime",
      name: "申请时间"
    },
    {
      key: "invoiceOrderId",
      name: "开票单号"
    },
    {
      key: "invoiceStatus",
      name: "开票状态"
    }
  ],
  organization: [
    {
      key: "invoiceTitle",
      name: "发票抬头"
    },
    {
      key: "invoiceAmount",
      name: "发票金额"
    },
    {
      key: "createTime",
      name: "申请时间"
    },
    {
      key: "invoiceOrderId",
      name: "开票单号"
    },
    {
      key: "invoiceStatus",
      name: "开票状态"
    }
  ],
  company: [
    {
      key: "invoiceTitle",
      name: "发票抬头"
    },
    {
      key: "invoiceAmount",
      name: "发票金额"
    },
    {
      key: "taxpayerId",
      name: "纳税人识别号"
    },
    {
      key: "createTime",
      name: "申请时间"
    },
    {
      key: "invoiceOrderId",
      name: "开票单号"
    },
    {
      key: "companyAddr",
      name: "单位地址"
    },
    {
      key: "companyPhone",
      name: "单位电话"
    },
    {
      key: "companyBankName",
      name: "开户银行"
    },
    {
      key: "companyBankAcct",
      name: "银行账户"
    },
    {
      key: "invoiceStatus",
      name: "开票状态"
    }
  ],
  special: [
    {
      key: "invoiceTitle",
      name: "发票抬头"
    },
    {
      key: "invoiceAmount",
      name: "发票金额"
    },
    {
      key: "createTime",
      name: "申请时间"
    },
    {
      key: "invoiceOrderId",
      name: "开票单号"
    },
    {
      key: "invoiceNoList",
      name: "发票物理票号"
    },
    {
      key: "invoiceStatus",
      name: "开票状态"
    },
    {
      key: "markOut",
      name: "驳回原因"
    }
  ]
}

/**
 * 订单开票状态 -3-申请失败 -2-已驳回  -1-已退票  0-开票初始态 1-开票中 2-待领取 3-已开票 4-待下载  99-未开票
 * 0-开票初始态 1-开票中 2-待领取 3-已开票[不可开票] 4-待下载[数电发票需要下载并上传cos]
 * -2 已驳回，不可再次开票（订单已开票，驳回的是取消发票这个操作，对于计平仍处于已开票状态）--- 普票在计平只有退票，没有驳回状态（驳回在财经那里，不会通知计平），专票有驳回状态，驳回订单可以重新开票
 * @type {number[]}
 */
export const cannotInvoiceStatus = [0, 1, 2, 3, 4]

// -3，-2，-1状态可重新开票，需隐藏开票单号
export const canInvoiceStatus = [-3, -2, -1]

export const mainBodyList = [
  {
    mainbodyName: "深圳市腾讯计算机系统有限公司",
    mainbodyID: "00000102",
    mainbodyIdList: [
      "1000018901",
      "1000023401",
      "1800000791",
      "1800000801",
      "1800006331",
      "1800007221",
      "1800007471",
      "1800007474",
      "1800009116"
    ]
  },
  {
    mainbodyName: "深圳市腾讯天游科技有限公司",
    mainbodyID: "00009496",
    mainbodyIdList: ["1800009391", "1800009428", "1800009320", "1800009427"]
  }
]
// 默认主体
export const defaultMainbody = {
  mainbodyName: "深圳市腾讯计算机系统有限公司",
  mainbodyID: "00000102"
}

// 账号类型
export const ACCOUNT_TYPE = {
  DUMMY: 0,
  QQ: 1,
  WX: 2,
  WX_BEAN: 3,
  THIRD: 4
}

// 查询年限
export const N_YEAR_AGO = +staticConfig.enableBeginTime || 3

// 订单类型
export const ORDER_TYPE_TEXT = {
  QB_ORDER: "Q币数据服务费",
  OTHER: "服务费"
}

// Q币数据服务费类型枚举，serviceCode不等于这几种即其他服务费
export const ORDER_TYPE_MAP = {
  QB_ORDER: ["QQACCT_SAVE", "-QQPOINT"]
}

// 提交开票请求错误弹窗提示
export const INVOICE_FAIL_TIPS = {
  PART_REFOUND: "您的如下订单有部分退款，扣除退款后，可申请发票的金额为",
  FULL_REFOUND: "您选择的订单已全部退款，不能开具发票",
  REFOUND_1: "您的如下订单有退款，扣除退款后，可申请发票的金额为",
  REFOUND_2: "您的如下订单已退款，扣除退款后，可申请发票的金额为",
  SENSITIVE_WORD: "您输入的内容存在敏感词，请确认后重新输入",
  SYSTEM_BUSY: "系统繁忙，请再次提交",
  PART_INVOICED: "您的如下订单已开票或正在开票中，不可重复开票，扣除该部分后，可申请发票的金额为",
  FULL_INVOICED: "您选择的订单已开票或开票中，不能开具发票"
}

// 发票文件类型
export const INVOICE_FILE_TYPE_MAP = {
  PDF: "pdf",
  XML: "xml",
  DOC: "ofd"
}
